// activity.priceUnit comes straight from the DB in whatever language it was
// typed in the admin panel (almost always Spanish: "persona", "grupo privado"...).
// Rendering it raw meant every non-Spanish visitor saw Spanish text after the
// price ("€79.21 / persona") regardless of their selected language. This maps
// the known raw values to all 6 site languages; an unrecognised value still
// falls back to the raw string instead of breaking.
const PRICE_UNIT_LABELS = {
  'persona': { es: 'persona', en: 'person', it: 'persona', de: 'Person', no: 'person', nl: 'persoon' },
  'persona desde': { es: 'persona', en: 'person', it: 'persona', de: 'Person', no: 'person', nl: 'persoon' },
  'grupo': { es: 'grupo', en: 'group', it: 'gruppo', de: 'Gruppe', no: 'gruppe', nl: 'groep' },
  'grupo privado': { es: 'grupo privado', en: 'private group', it: 'gruppo privato', de: 'Privatgruppe', no: 'privat gruppe', nl: 'privégroep' },
  'salida privada': { es: 'salida privada', en: 'private trip', it: 'uscita privata', de: 'private Tour', no: 'privat tur', nl: 'privétour' },
  'salida privada desde': { es: 'salida privada', en: 'private trip', it: 'uscita privata', de: 'private Tour', no: 'privat tur', nl: 'privétour' },
  'yate privado': { es: 'yate privado', en: 'private yacht', it: 'yacht privato', de: 'Privatyacht', no: 'privat yacht', nl: 'privéjacht' },
  'embarcación': { es: 'embarcación', en: 'boat', it: 'imbarcazione', de: 'Boot', no: 'båt', nl: 'boot' },
  'buggy': { es: 'buggy', en: 'buggy', it: 'buggy', de: 'Buggy', no: 'buggy', nl: 'buggy' },
  'canoa': { es: 'canoa', en: 'canoe', it: 'canoa', de: 'Kanu', no: 'kano', nl: 'kano' },
  'moto': { es: 'moto de agua', en: 'jet ski', it: 'moto d’acqua', de: 'Jetski', no: 'vannscooter', nl: 'jetski' },
  'vuelo': { es: 'vuelo', en: 'flight', it: 'volo', de: 'Flug', no: 'flytur', nl: 'vlucht' },
  'opción': { es: 'opción', en: 'option', it: 'opzione', de: 'Option', no: 'alternativ', nl: 'optie' },
};

export function translatePriceUnit(unit, lang) {
  const raw = (unit || '').trim();
  if (!raw) return '';
  const entry = PRICE_UNIT_LABELS[raw.toLowerCase()];
  if (!entry) return raw;
  return entry[lang] || entry.es || raw;
}
